import React, {useEffect, useMemo} from 'react';
import {Outlet, useNavigation, useNavigate} from 'react-router-dom';
import {getRootStore} from '../app.bootstrap';
import {DevNav} from '../components/dev-nav/DevNav';
import {runInAction} from 'mobx';

export const RootLayout: React.FC = () => {
    const rootStore = getRootStore();
    const navigation = useNavigation();
    const navigate = useNavigate();

    const isLoading = useMemo(() => {
        return navigation.state === 'loading';
    }, [navigation.state]);

    useEffect(() => {
        rootStore.tsReactStateHelper.setNavigate(navigate);

        return () => {
            rootStore.tsReactStateHelper.setNavigate(undefined);
        };
    }, [navigate, rootStore.tsReactStateHelper]);

    useEffect(() => {
        if (isLoading) {
            runInAction(() => (rootStore.appState.showGlobalLoader = true));
        } else {
            runInAction(() => (rootStore.appState.showGlobalLoader = false));
        }
    }, [navigation.state]);

    return (
        <>
            <DevNav />
            <Outlet />
        </>
    );
};
